// import { FiArrowRight } from "react-icons/fi";
// import { Link } from "react-router-dom";

const SingleBlogCard = ({
  // id,
  title,
  image,
  category,
  description,
}) => {
  return (
    <div className="mb-8 group">
      {/* Category Badge */}
      <div className="rounded-lg overflow-hidden">
        <span className="px-3 py-1 text-white capitalize rounded-full bg-secondary">
          {category}
        </span>

        {/* Images Section */}
        <div className="mt-4 flex flex-col sm:flex-row gap-4">
          <img
            src={image}
            alt={title}
            className="w-full sm:w-1/2 rounded-lg h-[250px] md:h-[400px] object-cover group-hover:scale-105 transition-transform duration-300 ease-in-out"
          />
          <img
            src={image}
            alt={title}
            className="w-full sm:w-1/2 rounded-lg h-[250px] md:h-[400px] object-cover group-hover:scale-105 transition-transform duration-300 ease-in-out"
          />
        </div>
      </div>

      {/* Title and Description */}
      <div className="mt-4">
        <h1 className="text-2xl font-semibold">{title}</h1>
        <p className="mt-3 text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default SingleBlogCard;
